import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  RadniNalogDto,
  RadniNaloziClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RadniNalogDuplikatResolver
  extends BaseService
  implements Resolve<RadniNalogDto> {
  constructor(private _client: RadniNaloziClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<RadniNalogDto> | Promise<RadniNalogDto> | RadniNalogDto | null {
    let id = 0;
    try {
      id = this._router.getCurrentNavigation().extras.state.id;
    } catch {
      return null;
    }

    return this._client.duplicateRadniNalog(id).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
